<template>
    <!-- Web Stepper -->
    <div
    v-if="!getMobileAppState"
    ref="stepsWrapper"
    class="steps-wrapper"
    :class="{'has-scroll': steps.length > 3, 'dont-animate': windowBeingResized}">
        <div
        class="step"
        v-for="(step, index) in steps"
        :key="step.stepNumber">
            <step
            :activeStep="activeStep"
            :stepNumber="index+1"
            :description="step.description"
            :totalSteps="steps.length"/>
            <span class="line" v-if="index !== steps.length - 1"/>
        </div>
    </div>
    <!-- Mobile Stepper -->
    <step
    v-else
    :activeStep="activeStep"
    :stepNumber="activeStep"
    :description="steps.find((el, index) => index+1 === activeStep).description"
    :totalSteps="steps.length"/>
</template>

<script setup>
import Step from '@/components/generic/stepper/Step'
/* Vue */
import { ref, watch, onMounted, onUnmounted } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* mapGetters */
const { getMobileAppState } = mapGetters()

/** Props received
@steps {Array} in which each object has:
	- description { String }
@activeStep {Number}
*/
const props = defineProps({
    steps: Array,
    activeStep: Number
})

const stepsWrapper = ref('')

watch(() => props.activeStep, () => {
    if (props.steps.length <= 3 || getMobileAppState.value) return
    calcCurrentLeftPosition()
})

const calcCurrentLeftPosition = () => {
    const startValue = stepsWrapper.value.offsetParent.children['helper-element-to-align-stepper'].offsetLeft
    // 200 is the step width
    let left = startValue - (200 * (props.activeStep - 1))
    const sizeDiff = stepsWrapper.value.clientWidth - stepsWrapper.value.offsetParent.children['helper-element-to-align-stepper'].clientWidth

    if (sizeDiff < (200 * (props.activeStep - 1))) left = startValue - sizeDiff
    setTimeout(() => { windowBeingResized.value = false }, 100)
    stepsWrapper.value.style.left = `${left}px`
}

const windowBeingResized = ref(false)
const getParentForReferenceLogic = () => {
    windowBeingResized.value = true
    calcCurrentLeftPosition()
}

onMounted(() => {
    if (getMobileAppState.value) return

    if (props.steps.length > 3) {
        getParentForReferenceLogic()
        window.addEventListener('resize', getParentForReferenceLogic)
    } else {
        stepsWrapper.value.style.width = `${stepsWrapper.value.offsetParent.children['helper-element-to-align-stepper'].clientWidth}px`
    }
})

onUnmounted(() => {
    window.removeEventListener('resize', getParentForReferenceLogic)
})
</script>

<style lang="scss" scoped>
.steps-wrapper {
    display: flex;
    justify-content: space-between;
    align-self: center;

    .step {
        display: flex;
        flex-direction: row;

        position: relative;

        &:not(:last-of-type) {
            width: 100%;
        }

        &:last-of-type {
            flex-shrink: 0;
        }
    }

    .line {
        width: calc(100% - 48px);
        height: 2px;
        background-color: var(--secondary);

        position: absolute;
        top: 23px;
        left: 48px;
    }

    &.has-scroll {
        position: relative;
        width: fit-content;
        align-self: auto;

        &:not(.dont-animate) {
            transition: left 0.4s ease-in-out;
        }

        .step {
            flex-shrink: 0;

            &:not(:last-of-type) {
                width: 200px;
            }
        }
    }
}
</style>
